import React from 'react'
import ListGroup from 'react-bootstrap/ListGroup';


const menu = () => {
  return (
    <>
    <ListGroup variant='flush'>
      <ListGroup.Item variant="info" className='opacity-75 py-lg-4 py-3'>Home</ListGroup.Item>
      <ListGroup.Item variant="info" className='opacity-75 py-lg-4 py-3'>Dapibus ac facilisis in</ListGroup.Item>
      <ListGroup.Item variant="info" className='opacity-75 py-lg-4 py-3'>Morbi leo risus</ListGroup.Item>
      <ListGroup.Item variant="info" className='opacity-75 py-lg-4 py-3'>Porta ac consectetur ac</ListGroup.Item>
      <ListGroup.Item variant="info" className='opacity-75 py-lg-4 py-3'>Vestibulum at eros</ListGroup.Item>
    </ListGroup>
    </>
  )
}

export default menu